var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credentials-details-with-async-fallback"},[_c('back-navigation-header',{attrs:{"on-back":_vm.handleBack,"disabled":_vm.isLoading,"show-back":!_vm.goToAsyncFallback}}),_vm._v(" "),(_vm.goToAsyncFallback)?_c('async-fallback',{attrs:{"source":_vm.source}}):_vm._t("credentials")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d0c20fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base-components/onboarding/CredentialsDetailsWithAsyncFallback.vue
// module id = null
// module chunks = 